import { useMediaQuery } from '@ori-ui/mui';
import { DESKTOP_BREAKPOINT } from "../constants";
export var useIsMobile = function useIsMobile() {
  return useMediaQuery("(max-width: ".concat(DESKTOP_BREAKPOINT, "px)"));
};